import { AnyElement, MuWidget } from "mu-widget/lib/MuWidget";

export class UiDialog extends MuWidget 
{
    title: string;
    message: string;
    buttons: DialogButton[] = [];

    public getPromise(): Promise<any> {
        return new Promise((resolve, reject) => { 
            this.promiseResolve = resolve;
        })
    }

    public resolve(btn: DialogButton) {
        if (this.promiseResolve) this.promiseResolve(btn.value);
        this.muRemoveSelf();
    }

    protected promiseResolve: (val: any) => void;

    beforeIndex(): void {
        this.muAppendContent(/*html*/`<dialog mu-id="dialog">
            <h3 mu-id="title"></h3>
            <p mu-id="message"></p>
            <div class="buttons" mu-id="buttons">
                <span mu-template="button" class="btn btn-primary" mu-widget="UiDialogButton"></span>
            </div>
        </dialog>`)
    }

    afterIndex(): void {
        for(const button of this.buttons) {
            this.muWidgetFromTemplate("button", "buttons", { button })
        }
        this.ui.title.innerText = this.title;
        this.ui.message.innerText = this.message;
        (this.ui.dialog as HTMLDialogElement).showModal();
    }
}

export class UiDialogButton extends MuWidget {
    button: DialogButton;
    afterIndex(): void {
        this.container.innerText = this.button.title;
    }

    container_click() {
        this.muParent.resolve(this.button);
    }

    //@ts-ignore
    muParent: UiDialog;
}

export type DialogButton = {
    title: string,
    value: any,
}

